import React from 'react';

import classNames from 'classnames';

const CHIP_CLASSES = 'tw-inline-flex tw-items-center tw-rounded-full tw-px-2 tw-py-0.5 tw-text-xs tw-whitespace-nowrap';

const INHERITED_CLASSES = 'tw-border tw-border-dashed tw-border-charcoal-50 tw-text-charcoal-75';

const UNTAGGED_CLASSES = 'tw-border tw-border-solid tw-border-charcoal-25 tw-text-charcoal-75';

// Own tags alternate tints by codeset so two codesets on one item read apart.
const OWN_CLASSES = ['tw-bg-blue-10 tw-text-blue tw-font-semibold', 'tw-bg-green-10 tw-text-dark-green tw-font-semibold'];

/**
 * An item's effective budget tags in its header's item grid: dashed grey chips while
 * it follows its header, solid chips and an "override" label once it sets its own.
 */
export default function BudgetTagChips({ cell }) {
    if (!cell) {
        return null;
    }

    const tags = cell.tags || [];

    return (
        <span className="tw-inline-flex tw-flex-wrap tw-items-center tw-gap-1">
            {tags.length === 0 && <span className={classNames(CHIP_CLASSES, cell.overrides ? UNTAGGED_CLASSES : INHERITED_CLASSES)}>{$t('Untagged')}</span>}
            {tags.map((tag) => (
                <span
                    key={tag.tag_id}
                    className={classNames(CHIP_CLASSES, cell.overrides ? OWN_CLASSES[(tag.category_id || 0) % OWN_CLASSES.length] : INHERITED_CLASSES)}
                >
                    {tag.item_name} {parseFloat(tag.percentage)}%
                </span>
            ))}
            {cell.overrides && <span className="tw-text-2xs tw-text-charcoal-50">{$t('override')}</span>}
        </span>
    );
}
